/* eslint-disable @typescript-eslint/no-unused-vars */
import { RegistrationEmail } from 'cpnl-common';
import { preventSubmit, ValidatedInput } from '@cp-shared-19/frontend-ui';
import { Button, ContentSection, Fieldset, Form, Heading, Layout, Logo, PageWrap } from '@vwfs-bronson/bronson-react';
import { loginInProgressPagePath } from 'components/navigation/paths';
import { Formik } from 'formik';
import React from 'react';
import { currentBrand } from '../../../../config';
import { RegistrationEmailFormFields } from './RegistrationEmailFormFields';
import { registrationEmailValidationSchema } from './registrationEmailValidationSchema';
import { useLogin } from 'auth';

export const RegistrationEmailUi: React.FC<{ registrationEmail?: RegistrationEmail }> = ({ registrationEmail }) => {
    const login = useLogin(loginInProgressPagePath);
    let logo;

    function redirectToIdentityKit(_email: string): Promise<void> {
        return login();
    }

    if (!registrationEmail) {
        return null;
    }

    if (currentBrand === 'df') {
        logo = (
            <Layout.Item className={'u-text-center'}>
                <img src={registrationEmail.logoUrl} className={'u-1/3 u-1/2@s u-1/1@xs'} alt="logo_DutchFinance" />
            </Layout.Item>
        );
    } else {
        logo = (
            <Layout.Item>
                <Logo className={'u-block-center'} />
            </Layout.Item>
        );
    }

    return (
        <ContentSection>
            <PageWrap size={'xsmall'}>
                <Layout>
                    {logo}
                    <Layout.Item className={'u-text-center'}>
                        <Heading level={2}>{registrationEmail.headline}</Heading>
                        <p>{registrationEmail.description.line1}</p>
                        <b>{registrationEmail.description.line2}</b>
                    </Layout.Item>
                    <Layout.Item>
                        <Formik
                            initialValues={{
                                email: '',
                            }}
                            validationSchema={registrationEmailValidationSchema(registrationEmail)}
                            onSubmit={(values: RegistrationEmailFormFields): void => {
                                redirectToIdentityKit(values.email);
                            }}
                        >
                            {(formik) => (
                                <Form onSubmit={preventSubmit}>
                                    <Fieldset>
                                        <Fieldset.Row>
                                            <ValidatedInput
                                                className="u-text-left c-form-field--no-floating"
                                                label={registrationEmail.email.label}
                                                name="email"
                                                inputMode={'email'}
                                                testId={'email'}
                                                autocomplete="email"
                                                required
                                            />
                                        </Fieldset.Row>
                                        <Fieldset.Row className={'u-text-center'}>
                                            <Button onClick={formik.submitForm} type="submit" testId={'continueButton'}>
                                                {registrationEmail.continue}
                                            </Button>
                                        </Fieldset.Row>
                                    </Fieldset>
                                </Form>
                            )}
                        </Formik>
                    </Layout.Item>
                </Layout>
            </PageWrap>
        </ContentSection>
    );
};
